import React from 'react';


export default function Logo() {
  return (
    <img src="https://ia601407.us.archive.org/8/items/img925/hoa_32x32.png"></img>
  );
}